export type PatientManagerSortBy =
  | 'last_name'
  | 'first_name'
  | 'mrn'
  | 'episode_start'
  | 'date_of_birth'
  | 'insurance_name'
  | 'city'
  | 'primary_dx_code';

/**
 * The Patient Manager table's sortable columns (EMR-2978).
 */
/**
 * Array of all PatientManagerSortBy values.
 * The Patient Manager table's sortable columns (EMR-2978).
 */
export const PATIENTMANAGERSORTBY_VALUES: readonly PatientManagerSortBy[] = [
  'last_name',
  'first_name',
  'mrn',
  'episode_start',
  'date_of_birth',
  'insurance_name',
  'city',
  'primary_dx_code',
] as const;
